'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.apps.edit', [])
  .controller('AppsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/apps/edit/index.js